import { render } from "./Preloader.vue?vue&type=template&id=0519858a"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=0519858a&lang=scss"

import exportComponent from "E:\\jev-router\\runs\\dating-services-20261022\\build-workspace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__